import { useCallback, useState } from 'react'
import { getApi } from '../../api/api'

export const useRefresh = () => {
  const [api] = useState(() => getApi())

  const refresh = useCallback(async () => {
    try {
      await api.refresh()
    } catch (error) {}
  }, [api])

  return { refresh }
}
